import en from 'dict/en'
import ro from 'dict/ro'
import bg from 'dict/bg'
import i18n from 'i18next'
import {initReactI18next, useTranslation} from 'react-i18next'

export const defaultNS = 'translation'
export const resources = {
    en: {translation: en},
    ro: {translation: ro},
    bg: {translation: bg},
} as const

const initialLanguageParamKey = 'lang'

const getInitialLanguage = () => {
    let initialLangauge = 'en'

    const browserLanguage = navigator.language
    if (browserLanguage in resources) {
        initialLangauge = browserLanguage
    }

    const params = new URLSearchParams(window.location.search)
    const urlLanguage = params.get(initialLanguageParamKey)
    if (urlLanguage && urlLanguage in resources) {
        initialLangauge = urlLanguage
    }

    return initialLangauge
}

void i18n.use(initReactI18next).init({
    resources,
    lng: getInitialLanguage(),
    defaultNS,
    interpolation: {
        escapeValue: false,
    },
})

export const useTypedTranslation = () => {
    const {t} = useTranslation()

    const typedT = (sourceText: string) => {
        return t(sourceText as keyof typeof en)
    }
    return {t: typedT}
}

export default i18n
